(function() {
    "use strict";

    angular.module('eSign')
      .service('validationService', function() {

          var mod11OfNumberWithControlDigit = function (input) {
              var controlNumber = 2,
                  sumForMod = 0,
                  i;

              for (i = input.length - 2; i >= 0; --i) {
                  sumForMod += input.charAt(i) * controlNumber;
                  if (++controlNumber > 7)
                      controlNumber = 2;
              }
              var result = (11 - sumForMod % 11);

              return result === 11 ? 0 : result;
          };

          this.validateSSN = function(ssn) {
              if (_.isString(ssn)) {
                  if (ssn.length === 11) {
                      var org = _.map(_.toArray(ssn), function(e) { return parseInt(e, 10) }),
                          arr = org.slice(0,9),
                          kt1 = [3,7,6,1,8,9,4,5,2],
                          kt2 = [5,4,3,2,7,6,5,4,3,2],
                          r1  = 0,
                          r2  = 0;

                      for (var i=0; i<arr.length; i++) {
                          r1 += arr[i] * kt1[i];
                      }

                      arr.push(r1 % 11 === 0 ? 0 : (11-(r1%11)))

                      for (var i=0; i<arr.length; i++) {
                          r2 += arr[i] * kt2[i];
                      }

                      arr.push(r2 % 11 === 0 ? 0 : (11-(r2%11)));

                      return arr.join('') === org.join('');
                }
              }
              return false;
          };

            this.validateSSN_FI = function (ssn) {
                if (_.isString(ssn)) {
                    if (ssn.length === 11) {
                        return /^[0-9]{6}-(?:[0-9]+){1,3}[0-9A-Za-z]$/.test(ssn);
                    }
                }
                return false;
            };

          this.validateAccountNumber = function (accountNumber) {
              if (!accountNumber) {
                  return false;
              }
              accountNumber = accountNumber.toString().replace(/\./g, '');
              if (accountNumber.length !== 11) {
                  return false;
              }
              return parseInt(accountNumber.charAt(accountNumber.length - 1), 10)
                      === mod11OfNumberWithControlDigit(accountNumber);
          };

      });
}());
